import { IMAGE_EDIT_PARAM, STUDIO_PATH } from 'Pods/ThreeDStudio/constants'

// Everything up to and including the Image Generator segment, so the locale prefix (/es) stays
// and a trailing slash or an older image's slug after it is dropped.
const IMAGE_GENERATOR_PREFIX = new RegExp(`^(.*${STUDIO_PATH.IMAGE_GENERATOR})(?:/.*)?$`)

// Points the address bar at an image's own edit URL (/<locale>/ai-image/:slug?edit=true) without
// a route change. The router keeps its location, so nothing re-renders: the editor the Create
// page just opened stays as it is, and only a reload or a shared link resolves the URL, through
// ImageDeepLink. React Router's own history state is passed back untouched. Returns the URL it
// replaced so it can be restored, or null when it changed nothing: no slug, or a page outside
// the Image Generator.
export const replaceWithImageEditUrl = (slug) => {
  if (!slug || typeof window === 'undefined') return null

  const { pathname, search, hash } = window.location
  const prefix = pathname.match(IMAGE_GENERATOR_PREFIX)?.[1]
  if (!prefix) return null

  const params = new URLSearchParams(search)
  params.set(IMAGE_EDIT_PARAM, 'true')

  window.history.replaceState(window.history.state, '', `${prefix}/${slug}?${params.toString()}${hash}`)

  return `${pathname}${search}${hash}`
}

export const restoreUrl = (url) => {
  if (!url || typeof window === 'undefined') return

  window.history.replaceState(window.history.state, '', url)
}
